import jwt from 'jsonwebtoken';
import _ from 'lodash';
export const verify = (key, value, { clientType, algorithms, ignoreExpiration }) => {
    const clientTypes = _.isArray(clientType) ? clientType : [clientType];
    if (!value) {
        return Promise.resolve(null);
    }
    return new Promise((resolve, reject) => {
        return jwt.verify(value, key, { algorithms, ignoreExpiration }, (err, payload) => {
            if (payload) {
                const jwt = payload;
                if (!clientTypes.includes(jwt.clientType)) {
                    const expected = clientTypes.join('|');
                    reject(`Incorrect clientType '${jwt.clientType}'. Expected '${expected}'`);
                }
                return resolve(payload);
            }
            else {
                console.error('jwt verification failed', err);
                return resolve(null);
            }
        });
    });
};
export const sign = (key, value, opts) => {
    try {
        return jwt.sign(value, key, opts);
    }
    catch (err) {
        console.error('jwt signing error', err);
    }
    return null;
};
//# sourceMappingURL=JwtUtilities.js.map